module.exports = __webpack_public_path__ + "static/media/screen2.a2a03eb0.png";